var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component"},[_c('img',{attrs:{"src":require("@/assets/daitongguo.png"),"alt":""}}),_c('div',[_vm._v("派单方认证消息审核中，请耐心等待...")])])}]

export { render, staticRenderFns }